import { render, staticRenderFns } from "./MitigationsVulnerabilitiesTable.vue?vue&type=template&id=0aa1da14&"
import script from "./MitigationsVulnerabilitiesTable.vue?vue&type=script&lang=js&"
export * from "./MitigationsVulnerabilitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports